import React, { useState, useCallback, useMemo } from "react";
import SlowMotionVideoIcon from "@material-ui/icons/SlowMotionVideo";
import { Menu, MenuItem, Theme, createStyles, makeStyles } from "@material-ui/core";

interface Props {
  videoRef: React.MutableRefObject<HTMLVideoElement | null>;
  buttonStyles: string;
  containerRef: React.MutableRefObject<HTMLDivElement | null>;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    selectedPlaybackSpeed: {
      backgroundColor: theme.palette.primary.light,
    },
  })
);

const PlaybackSpeedButton = ({ videoRef, buttonStyles, containerRef }: Props) => {
  const classes = useStyles();
  const [openSelectPlaybackSpeed, setOpenSelectPlaybackSpeed] = useState<null | HTMLElement>(null);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const PLAYBACK_SPEEDS = [0.25, 0.5, 1, 1.25, 1.5, 2, 3];
  const PARENT_CONTAINER = containerRef.current;
  const changePlaybackSpeed = useCallback(
    (speed: number) => {
      if (!videoRef.current) {
        return;
      }
      videoRef.current.playbackRate = speed;
      setOpenSelectPlaybackSpeed(null);
      setPlaybackSpeed(speed);
    },
    [videoRef]
  );

  const menuItems = useMemo(
    () =>
      PLAYBACK_SPEEDS.map((speed) => (
        <MenuItem
          key={speed}
          onClick={() => changePlaybackSpeed(speed)}
          className={speed === playbackSpeed ? classes.selectedPlaybackSpeed : ""}
        >
          {speed}x
        </MenuItem>
      )),
    [playbackSpeed]
  );

  return (
    <>
      <button
        id="playbackSpeed"
        className={buttonStyles}
        type="button"
        onClick={(event) => {
          setOpenSelectPlaybackSpeed(event.currentTarget);
        }}
        title="Playback Speed"
      >
        <SlowMotionVideoIcon />
      </button>
      <Menu
        id="playbackSpeedMenu"
        anchorEl={openSelectPlaybackSpeed}
        keepMounted
        container={PARENT_CONTAINER}
        open={Boolean(openSelectPlaybackSpeed)}
        onClose={() => setOpenSelectPlaybackSpeed(null)}
      >
        {menuItems}
      </Menu>
    </>
  );
};

export default PlaybackSpeedButton;
